export const SLUG_CLAIM_SINGULAR = 'claim';
export const SLUG_DASHBOARD = 'dashboard';
export const SLUG_REIMBURSEMENT = 'claim-reimbursement';
export const SLUG_PREAUTH = 'preauth';
export const SLUG_PRESCRIPTION = 'prescription';
export const SLUG_CLAIMS = `${SLUG_CLAIM_SINGULAR}s`;
export const SLUG_POLICY = 'policy';
export const SLUG_NOTIFICATION = 'notification-center';
export const SLUG_FAQ = 'faq';
export const SLUG_UPLOAD_SUMMARY = 'upload-summary';
export const SLUG_ROLES = 'roles';
export const SLUG_PERMISSIONS = 'permissions';
export const SLUG_VIEW_CLAIMS = 'view-claims';
export const SLUG_FOLLOW_UP = 'follow-up';
export const SLUG_REJECT = 'reject';
export const SLUG_RELATED_CLAIM = 'related-claim';
export const SLUG_DENIAL = 'denial-management';

export const ROUTE_DASHBOARD = `/${SLUG_DASHBOARD}`;
export const ROUTE_ELIGIBILITY = '/eligibility';
export const ROUTE_PRESCRIPTION = `/${SLUG_PRESCRIPTION}`;
export const ROUTE_PREAUTH = `/${SLUG_PREAUTH}`;
export const ROUTE_CLAIM = `/${SLUG_CLAIM_SINGULAR}`;
export const ROUTE_CONVERT = '/convert';
export const ROUTE_NETWORK = '/network-management';
export const ROUTE_POLICY = '/policy-management';
export const ROUTE_PAYMENT = '/payment';
export const ROUTE_RECONCILIATION = '/payment-reconciliation';
export const ROUTE_INSURANCE = '/insurance-company';
export const ROUTE_CONFIG = '/configuration';
export const ROUTE_ADMIN = '/administrator';
export const ROUTE_USER_INFO = '/user-info';
export const ROUTE_SETTINGS = '/settings';
export const ROUTE_COMMUNICATION = '/communication';
export const ROUTE_REPORTS = '/reports';
export const ROUTE_PAYER_PROVIDER = `${ROUTE_SETTINGS}/payer-provider-setting`;
export const PATH_ROUTE_EXTERNAL = `${ROUTE_REPORTS}/external-charts`;

export const PATH_ELIGIBILITY_TRANS = `${ROUTE_ELIGIBILITY}/transactions`;

export const PATH_PRESCRIPTION_TRANS = `${ROUTE_PRESCRIPTION}/transaction`;
export const PATH_PRESCRIPTION_QUEUE = `${ROUTE_PRESCRIPTION}/prescription-queue`;
export const PATH_PRESCRIPTION_MY = `${ROUTE_PRESCRIPTION}/my-prescription`;

export const PATH_PREAUTH_TRANS = `${ROUTE_PREAUTH}/transaction`;
export const PATH_PREAUTH_QUEUE = `${ROUTE_PREAUTH}/approval-queue`;
export const PATH_PREAUTH_MY = `${ROUTE_PREAUTH}/my-approval`;
export const PATH_ADV_PREAUTH_TRANS = `${ROUTE_PREAUTH}/advance/transaction`;
export const PATH_PREAUTH_REVIEW = `${ROUTE_PREAUTH}/review`;

export const PATH_CLAIM_UPLOAD = `${ROUTE_CLAIM}/upload`;
export const PATH_CLAIM_SEARCH = `${ROUTE_CLAIM}/search-claim`;
export const PATH_CLAIM_MY = `${ROUTE_CLAIM}/my-claims`;
export const PATH_CLAIM_BATCH = `${ROUTE_CLAIM}/batch`;
export const PATH_PROVIDER_BATCH = `${ROUTE_CLAIM}/provider-batch`;
export const PATH_CLAIM_TRANS = `${ROUTE_CLAIM}/transaction`;
export const PATH_CLAIM_REIMBURSE = `${ROUTE_CLAIM}/${SLUG_REIMBURSEMENT}/transaction`;
export const PATH_CLAIM_HISTORY = `${ROUTE_CLAIM}/claim-history`;

export const PATH_NETWORK_PROVIDER = `${ROUTE_NETWORK}/provider`;
export const PATH_NETWORK_PRICE = `${ROUTE_NETWORK}/price-list`;
export const PATH_NETWORK_CONTRACT = `${ROUTE_NETWORK}/contract`;
export const PATH_NETWORKS = `${ROUTE_NETWORK}/networks`;

export const PATH_POLICY_POLICY = `${ROUTE_POLICY}/policy`;
export const PATH_POLICY_BENEFICIARY = `${ROUTE_POLICY}/beneficiary`;
export const PATH_POLICY_CLASS = `${ROUTE_POLICY}/policy-class`;
export const PATH_POLICY_BENEFIT = `${ROUTE_POLICY}/benefit`;

export const PATH_PAYMENT_TRANS = `${ROUTE_PAYMENT}/transaction`;
export const PATH_RECONCILIATION_TRANS = `${ROUTE_RECONCILIATION}/transaction`;

export const PATH_CONFIG_MASTER = `${ROUTE_CONFIG}/master-data`;
export const PATH_CONFIG_LOV = `${ROUTE_CONFIG}/commonlov`;
export const PATH_CONFIG_CLAIM_TYPE = `${ROUTE_CONFIG}/claim-type`;
export const PATH_CONFIG_REASON = `${ROUTE_CONFIG}/reason`;
export const PATH_CONFIG_ENCOUNTER = `${ROUTE_CONFIG}/encounter-class`;
export const PATH_CONFIG_MORPHOLOGY = `${ROUTE_CONFIG}/morphology`;
export const PATH_CONFIG_SERVICE_TYPE = `${ROUTE_CONFIG}/servicetypes`;
export const PATH_CONFIG_SERVICE_CODE = `${ROUTE_CONFIG}/service-code`;
export const PATH_CONFIG_LOINC = `${ROUTE_CONFIG}/loinc-code`;
export const PATH_CONFIG_PHYSICIAN = `${ROUTE_CONFIG}/physician`;
export const PATH_CONFIG_DIAGNOSIS = `${ROUTE_CONFIG}/diagnosis`;
export const PATH_CONFIG_SPECIALITY = `${ROUTE_CONFIG}/speciality`;
export const PATH_CONFIG_BODY_SUB = `${ROUTE_CONFIG}/bodysubsite`;
export const PATH_CONFIG_BODY_SITE = `${ROUTE_CONFIG}/bodysite`;
export const PATH_CONFIG_PHARMA_FORM = `${ROUTE_CONFIG}/pharmaceutical-form`;
export const PATH_CONFIG_DOSAGE = `${ROUTE_CONFIG}/dosage-type`;
export const PATH_CONFIG_UCUM = `${ROUTE_CONFIG}/ucum-code`;
export const PATH_CONFIG_DEVICE = `${ROUTE_CONFIG}/medical-device`;

export const PATH_ADMIN_USERS = `${ROUTE_ADMIN}/users`;
export const PATH_ADMIN_ROLES = `${ROUTE_ADMIN}/role-permission`;
export const PATH_ADMIN_AUDIT = `${ROUTE_ADMIN}/audit-log`;
export const PATH_ADMIN_FAQ = `${ROUTE_ADMIN}/${SLUG_FAQ}`;

export const ROUTE_DENIAL = `/${SLUG_DENIAL}`;
export const ROUTE_PROV_POLICY = `/${SLUG_POLICY}`;
export const ROUTE_PROV_BENEFICIARY = '/beneficiary';
